import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import RubySvgColor from '../assets/ruby.svg';

export const RubyColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-ruby" className={cx('sdkIcon', className)} size={size} {...props}>
    <RubySvgColor />
  </LegacyIcon>
);
